import type { ComponentProps, FC } from 'react';
import { forwardRef } from 'react';

import { Icon, IconName } from '@catalyze/ui';

import { Container } from './styled';

type IDropdownProps = ComponentProps<typeof Container> & {
    label: string;
};

export const Dropdown: FC<IDropdownProps> = forwardRef(
    ({ label, ...props }, ref) => {
        return (
            <Container {...props} ref={ref}>
                {label}
                <Icon iconName={IconName.SORT} />
            </Container>
        );
    }
);
